<!-- This file is generated by `npm run import-icons` - don't edit it manually! -->
<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M12.021 7.69c-.722 0-1.349.415-1.653 1.023l-.107.214a.48.48 0 0 1-.643.215l-.428-.215a.48.48 0 0 1-.215-.643l.108-.214a3.284 3.284 0 1 1 4.685 4.249c-.305.191-.577.404-.767.63-.187.222-.261.415-.261.59v.627a.48.48 0 0 1-.48.48h-.479a.48.48 0 0 1-.479-.48v-.626c0-.619.272-1.129.599-1.517.324-.385.734-.69 1.101-.921a1.846 1.846 0 0 0-.981-3.41m-.016 8.14a.96.96 0 1 0 0 1.919.96.96 0 0 0 0-1.92"/>
    <path fill="currentColor" fill-rule="evenodd" d="M12 2.5a9.5 9.5 0 1 0 0 19 9.5 9.5 0 0 0 0-19M4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0" clip-rule="evenodd"/>
  </svg>
</template>

<script>
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'BSvgCircleHelp',
})
</script>
